import type { ReactNode } from "react";
import { Toast as ToastRadix } from "radix-ui";
import { icons, type IconName } from "../../icons";
import Button from "../Button/Button";
import styles from "./Toast.css";

const iconSize = "1.5rem";

interface ToastProviderProps {
  children: ReactNode;
}

export const ToastProvider = ({ children }: ToastProviderProps) => {
  return (
    <ToastRadix.Provider>
      {children}
      <ToastRadix.Viewport className={styles.viewport} />
    </ToastRadix.Provider>
  );
};

interface ToastProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  icon: IconName;
  closeLabel: string;
  duration?: number;
}

const Toast = ({
  open,
  onOpenChange,
  title,
  description,
  icon,
  closeLabel,
  duration,
}: ToastProps) => {
  const Icon = icons[icon];

  return (
    <ToastRadix.Root
      className={styles.root}
      open={open}
      onOpenChange={onOpenChange}
      duration={duration}
    >
      <div className={styles.wrapper}>
        <span className={styles.icon}>
          <Icon size={iconSize} />
        </span>
        <div className={styles.textBlock}>
          <ToastRadix.Title className={styles.title}>{title}</ToastRadix.Title>
          {description ? (
            <ToastRadix.Description className={styles.description}>
              {description}
            </ToastRadix.Description>
          ) : null}
        </div>
      </div>
      <span className={styles.close}>
        <Button
          variant="secondary"
          color="success"
          size="small"
          title={closeLabel}
          onClick={() => onOpenChange(false)}
        />
      </span>
    </ToastRadix.Root>
  );
};

export default Toast;
